import { RootState } from '../store/store';

export const selectAnswerReducer = (state: RootState) =>
  state.answerReducer || {};
